export const configConstants = {
  API_URL: process.env.REACT_APP_API_URL,
  headers: {
    "X-IBM-Client-Secret": process.env.REACT_APP_IBM_Client_Secret,
    "X-IBM-Client-Id": process.env.REACT_APP_IBM_Client_ID
  },
  version: "5.1.3"
};
